import DateLabel from '../date/DateLabel';
import { PrizeInfo } from '../types';

const medalsLabels = [
  "Médaille d'Or",
  "Médaille d'Argent",
  'Médaille de Bronze',
];

const medalsColors = ['bg-ffbb-medal-gold', 'bg-ffbb-medal-silver', 'bg-ffbb-medal-bronze'];

interface Props {
  data: PrizeInfo;
}

const getMedalColor = (rank: string): string => {
  if (rank.length === 1 && parseInt(rank, 10) < 4) {
    return medalsColors[parseInt(rank, 10) - 1];
  }
  return '';
};

const getRankLabel = (rank: string): string => {
  if (rank.length === 1 && parseInt(rank, 10) < 4) {
    return medalsLabels[parseInt(rank, 10) - 1];
  }
  return `${rank.trim()}ème place`;
};

export default function PrizeItem({ data: { date, location, rank } }: Props) {
  const medalColor = getMedalColor(rank || '');
  return (
    <div className="flex h-[95px] w-full flex-col justify-start gap-4 rounded-lg bg-white p-2.5 lg:h-[69px] lg:flex-row lg:items-center">
      <div className="flex w-full">
        <div className="flex w-full flex-grow flex-col lg:flex-row">
          <span className="lg:w-40 lg:text-center">
            <DateLabel isoDate={date} type="year" color="dark" styles="font-normal"></DateLabel>
          </span>
          <span className="w-64 text-sm text-gray-400">{location}</span>
          <span className="grow text-sm font-bold">{getRankLabel(rank || '')}</span>
          <div className="hidden h-[30px] w-32 justify-center lg:flex">
            <span className={`h-[30px] w-[30px] rounded-full ${medalColor}`}></span>
          </div>
        </div>
        <div className="flex h-full items-center justify-end lg:hidden">
          <span className={`h-[30px] w-[30px] rounded-full ${medalColor}`}></span>
        </div>
      </div>
    </div>
  );
}
